import { booking, totalProviders } from '@assets/icons'
import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'

import Column from '@components/column'
import Title from '@components/title'
import Tab from '@components/tabs'
import DashboardCard from '@commons/cards/dashboard'
import VerificationRequest from './verification-request'
import RejectedRequest from './rejected-request'
import ProviderList from '@pages/admin/user-management/providers/provider-list'

const cardConfig = [
  {
    key: 'totalProviders',
    title: 'Total Providers',
    icon: totalProviders,
    isUp: true,
    link: '/admin/user-management/providers',
  },
  {
    key: 'totalBookings',
    title: 'Total Bookings',
    icon: booking,
    isUp: true,
    link: '/admin/bookings',
  },
  {
    key: 'totalActiveBooking',
    title: 'Active Bookings',
    icon: booking,
    isUp: false,
    link: '/admin/bookings?tab=Active%20Bookings',
  },
  {
    key: 'totalCompletedBooking',
    title: 'Completed Bookings',
    icon: booking,
    isUp: false,
    link: '/admin/bookings?tab=Completed%20Bookings',
  },
]
const ProviderManagement = () => {
  const navigate = useNavigate()

  const tabItems = [
    {
      label: 'Provider List',
      component: ProviderList,
    },
    {
      label: 'Verification Request',
      component: VerificationRequest,
    },
    {
      label: 'Rejected List',
      component: RejectedRequest,
    },
  ]

  return (
    <Fragment>
      <Column>
        <DashboardCard cardConfig={cardConfig} />
        <Title textone="Provider" texttwo="Management" />
        <Tab items={tabItems} />
      </Column>
    </Fragment>
  )
}

export default ProviderManagement
